import { EntityType } from "@mapmycustomers/shared";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import DealFieldName from "@app/util/fieldModel/DealFieldName";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { getSimpleConditionForField } from "@app/util/filters/utils";
import { convertFromPlatformFilterModel } from "@app/util/viewModel/convertFromPlatformFilterModel";

// Reads the funnel filter the user set on the card and returns the selected funnel ids.
// Returns undefined when there is no funnel filter, which makes getWonStageIds fall back to
// all funnels. For a NONE_OF filter we return the complement (all funnels minus the excluded).
const getSelectedFunnelIds = (
  extraFilters: PlatformFilterModel | undefined,
  allFunnelIds: Funnel["id"][]
): Funnel["id"][] | undefined => {
  if (!extraFilters) {
    return undefined;
  }

  const fieldModel = getFieldModelByEntityType(EntityType.DEAL);
  const filterModel = convertFromPlatformFilterModel(extraFilters, fieldModel);
  const condition = getSimpleConditionForField(filterModel, DealFieldName.FUNNEL);
  if (!condition) {
    return undefined;
  }

  const { operator, value } = condition;
  if (operator === FilterOperator.EQUALS) {
    return [value as Funnel["id"]];
  }
  if (operator === FilterOperator.IN_ANY && Array.isArray(value)) {
    return value as Funnel["id"][];
  }
  if (operator === FilterOperator.NONE_OF && Array.isArray(value)) {
    const excludedIds = new Set<Funnel["id"]>(value as Funnel["id"][]);
    return allFunnelIds.filter((id) => !excludedIds.has(id));
  }

  return undefined;
};

export default getSelectedFunnelIds;
